function Resolvable(handler) {
    let resolve;
    let reject;
    const result = new Promise((res, rej) => {
        resolve = res;
        reject = rej;
        if (handler == null) {
            return;
        }
        if (typeof handler === 'function') {
            handler(res, rej);
        }
        else if (handler.constructor === Promise) {
            handler.then(res, rej);
        }
    });
    result.resolve = resolve;
    result.reject = reject;
    return result;
}
export default Resolvable;
